<template>
  <div>
    <span class='bounding-box' ref='BBx' v-text='unit(boundingBox.size.x, "W")' :style="{ left: corners.x.x + 'px', top: corners.x.y + 'px' }"></span>
    <span class='bounding-box' ref='BBy' v-text='unit(boundingBox.size.y, "H")' :style="{ left: corners.y.x + 'px', top: corners.y.y + 'px' }"></span>
    <span class='bounding-box' ref='BBz' v-text='unit(boundingBox.size.z, "D")' :style="{ left: corners.z.x + 'px', top: corners.z.y + 'px' }"></span>
  </div>
</template>

<script>

export default {
  name: 'BoundingBox',
  props: {
    corners: {
      type: Object,
      default: () => {
        return {
          x: { x: 0, y: 0 },
          y: { x: 0, y: 0 },
          z: { x: 0, y: 0 }
        };
      }
    },
    boundingBox: {
      type: Object,
      default: () => {
        return {
          size: {
            x: 0, y: 0, z: 0
          }
        };
      }
    }
  },
  mounted () {
  },
  methods: {
    unit (v, part = 'W') {
      return `${part}:${Math.floor(v * 1000)}mm`;
    }
  }
};

</script>

<style lang="scss" scoped>

.bounding-box {
  pointer-events: none;

  display: block;
  position: absolute;
  font-weight: 500;
  font-size: 18px;
  z-index: 100;
  color: #35383b;
}

</style>



// WEBPACK FOOTER //
// src/components/viewer/BoundingBox.vue